/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Credits_SubmittingInputs */

const en_admin_users_credits_submitting = /** @type {(inputs: Admin_Users_Credits_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitting...`)
};

const zh_admin_users_credits_submitting = /** @type {(inputs: Admin_Users_Credits_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交中...`)
};

/**
* | output |
* | --- |
* | "Submitting..." |
*
* @param {Admin_Users_Credits_SubmittingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_credits_submitting = /** @type {((inputs?: Admin_Users_Credits_SubmittingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Credits_SubmittingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_credits_submitting(inputs)
	return zh_admin_users_credits_submitting(inputs)
});
export { admin_users_credits_submitting as "admin.users.credits_submitting" }